import { EmailCaptureForm, SectionTitle } from '@mc/educator-design-system'
import { Trans, useTranslation } from '@mc/i18n'
import { LEGAL_URLS } from '../../../../constants/legalUrls'
import { useFireEvent } from '../../../../tracking/educatorTracking'
import { isValidEmail } from '../../../../utils/validation'
import { SectionContainer } from '../../SectionContainer'

export const SubjectEmailCaptureSection = () => {
  const { t } = useTranslation('@mc/educator')
  const fireEvent = useFireEvent()

  return (
    <section data-section='subject-email-capture'>
      <div className='md:hidden'>
        <SectionContainer>
          <SectionTitle
            title={t('subjectLandingPage.subjectEmailCapture.sectionTitle')}
          />
        </SectionContainer>
      </div>
      <SectionContainer className='flex flex-col items-start md:items-center'>
        <EmailCaptureForm
          description={t('enrollment.admissions.emailForm.description')}
          placeholder={t('enrollment.admissions.emailForm.placeholder')}
          submitLabel={t('enrollment.admissions.emailForm.submitLabel')}
          consentText={t('enrollment.admissions.emailForm.consent')}
          termsContent={
            <Trans
              i18nKey='enrollment.admissions.emailForm.terms'
              ns='@mc/educator'
              components={{
                termsLink: (
                  <a
                    href={LEGAL_URLS.termsOfService}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white underline'
                  />
                ),
                privacyLink: (
                  <a
                    href={LEGAL_URLS.privacy}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white underline'
                  />
                ),
              }}
            />
          }
          invalidEmailError={t('enrollment.admissions.emailForm.invalidEmail')}
          termsRequiredError={t(
            'enrollment.admissions.emailForm.termsRequired',
          )}
          successMessage={t('enrollment.admissions.emailForm.successMessage')}
          onSubmit={(email, agreedToUpdates) =>
            fireEvent('educatorEmailCaptured', {
              email,
              location: 'stay informed',
              action: 'submit',
              marketing_consent: agreedToUpdates,
            })
          }
          validateEmail={isValidEmail}
          className='items-start md:items-center py-[40px]'
          descriptionClassName='text-left md:text-center'
        />
      </SectionContainer>
    </section>
  )
}
